import { AreasTariffSettingsWrapper, SectionHeading } from './style'
import { TariffList } from './TariffList'

interface AreasTariffSettingsProps {
    AreaPhotos: React.ReactNode
    isEditable: boolean
}

export function AreasTariffSettings({ AreaPhotos, isEditable }: AreasTariffSettingsProps) {
    return (
        <AreasTariffSettingsWrapper>
            <SectionHeading>Тарифы</SectionHeading>
            <TariffList isEditable={isEditable} />
            {AreaPhotos}
        </AreasTariffSettingsWrapper>
    )
}
